export const colors = {
	'BTC': { color: '#f7931a' },
	'BCH': { color: '#00c800' },
	'ETH': { color: '#627eea' },
	'LTC': { color: '#838383' }
}
